'use es6';

import * as Frequency from 'reporting-data/constants/frequency';
export const HUBSPOT_VIDEO_CRM_OBJECT_TYPE = '0-57';
export const VIDEO_VIEWS_QUERY_FIELD_NAME = 'videoViews';
export const VIDEO_RETENTION_QUERY_FIELD_NAME = 'videoRetention';
export const RETENTION_REPORT_NAME = 'e_mb_media_views_per_second_on_page';
export const DATEINT_FORMAT = 'YYYYMMDD';
export const BUCKET_DATE_KEY_FORMAT = 'YYYY-MM-DD';
export const DATE_FORMAT_BY_FREQUENCY = {
  [Frequency.DAY]: 'l',
  [Frequency.WEEK]: 'l',
  [Frequency.MONTH]: 'MMM Y'
};